import { render, staticRenderFns } from "./Business-Intelligence-Tools.vue?vue&type=template&id=6095e812&scoped=true&"
import script from "./Business-Intelligence-Tools.vue?vue&type=script&lang=js&"
export * from "./Business-Intelligence-Tools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6095e812",
  null
  
)

export default component.exports